export default __webpack_public_path__ + "static/media/IMG_0465.f25904b7.jpeg";